export default "<div class=\"wrapper\">\n    <aff-main-container></aff-main-container>\n</div>\n"